import { LOGOUT, SET_CURRENT_USER, SET_SELECTED_USER, SET_USERS_LIST } from "../actions/types";

const INITIAL_STATE = {
    current: {
        userID: null,
        email: null,
        fname: null,
        lname: null,
        ouID: null,
        ouName: null,
        externalOuID: null,
        externalOuName: null,
        subUnits: [],
        isSupervisor: null,
        coordinatedUnits: [],
        isCoordinator: null,
        onLeave: null,
        active: null,
        locked: null,
        intern: null,
        admin: null
    },
    selected: {
        userID: null,
        email: null,
        fname: null,
        lname: null,
        ouID: null,
        ouName: null,
        externalOuID: null,
        externalOuName: null,
        subUnits: [],
        isSupervisor: null,
        coordinatedUnits: [],
        onLeave: null,
        active: null,
        locked: null,
        intern: null,
        admin: null
    },
    list: []
};

const userReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_CURRENT_USER:
            return {
                ...state,
                current: {
                    userID: action.payload.userID,
                    email: action.payload.email,
                    fname: action.payload.fname,
                    lname: action.payload.lname,
                    ouID: action.payload.ouID,
                    ouName: action.payload.ouName,
                    externalOuID: action.payload.externalOuID,
                    externalOuName: action.payload.externalOuName,
                    subUnits: action.payload.subUnits.map(subUnit => {
                        return {
                            ouName: subUnit.ouName,
                            priority: subUnit.priority,
                            ranking: subUnit.ranking,
                            dateFrom: subUnit.dateFrom,
                            dateTo: subUnit.dateTo
                        };
                    }),
                    isSupervisor: action.payload.isSupervisor,
                    coordinatedUnits: action.payload.coordinatedUnits.map(coordinatedUnit => {
                        return {
                            externalOuID: coordinatedUnit.externalOuID,
                            name: coordinatedUnit.name
                        };
                    }),
                    isCoordinator: action.payload.isCoordinator,
                    onLeave: action.payload.onLeave,
                    active: action.payload.active,
                    locked: action.payload.locked,
                    intern: action.payload.intern,
                    admin: action.payload.admin
                }
            };
        case SET_SELECTED_USER:
            return {
                ...state,
                selected: {
                    userID: action.payload.userID,
                    email: action.payload.email,
                    fname: action.payload.fname,
                    lname: action.payload.lname,
                    ouID: action.payload.ouID,
                    ouName: action.payload.ouName,
                    externalOuID: action.payload.externalOuID,
                    externalOuName: action.payload.externalOuName,
                    subUnits: action.payload.subUnits.map(subUnit => {
                        return {
                            ouName: subUnit.ouName,
                            priority: subUnit.priority,
                            ranking: subUnit.ranking,
                            dateFrom: subUnit.dateFrom,
                            dateTo: subUnit.dateTo
                        };
                    }),
                    isSupervisor: action.payload.isSupervisor,
                    coordinatedUnits: action.payload.coordinatedUnits.map(coordinatedUnit => {
                        return {
                            externalOuID: coordinatedUnit.externalOuID,
                            name: coordinatedUnit.name
                        };
                    }),
                    onLeave: action.payload.onLeave,
                    active: action.payload.active,
                    locked: action.payload.locked,
                    intern: action.payload.intern,
                    admin: action.payload.admin
                }
            };
        case SET_USERS_LIST:
            return {
                ...state,
                list: action.payload.map(user => {
                    return {
                        userID: user.userID,
                        email: user.email,
                        fname: user.fname,
                        lname: user.lname
                    };
                })
            }
        case LOGOUT:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default userReducer;